import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FaExclamationTriangle, FaTimes, FaTrash } from 'react-icons/fa';

const DeleteGiftModal = ({
  isOpen,
  deleteInput,
  onDeleteInputChange,
  onCancel,
  onConfirm,
  theme,
}) => {
  const canDelete = deleteInput.toUpperCase() === 'DELETE';

  return (
    <AnimatePresence>
      {isOpen && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#2D2538]/60 p-6 backdrop-blur-md"
          onMouseDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
        >
          <motion.div
            initial={{ scale: 0.94, opacity: 0, y: 18 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.94, opacity: 0, y: 18 }}
            className="lumirae-ds-panel w-full max-w-sm p-6 shadow-2xl"
            style={{
              '--lumirae-accent-primary': theme.accent,
              '--lumirae-accent-soft': theme.accentSoft,
              '--lumirae-surface-raised': theme.cardBg,
              '--lumirae-border-default': theme.cardBorder,
              '--lumirae-text-primary': theme.text,
              '--lumirae-text-secondary': theme.secondaryText,
            }}
          >
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[1.25rem] bg-red-50 text-red-500">
                <FaExclamationTriangle />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-xl font-black uppercase tracking-tight text-red-500">Delete Gift</h3>
                <p className="mt-2 text-sm font-bold leading-relaxed" style={{ color: theme.secondaryText || theme.text }}>
                  This resets the gift content, uploads, and password. The same link will reopen with default password 123456.
                </p>
              </div>
              <button type="button" onClick={onCancel} className="lumirae-ds-icon-button h-9 w-9" aria-label="Cancel delete">
                <FaTimes />
              </button>
            </div>

            <div className="lumirae-ds-soft-note mt-5 p-4">
              <p className="text-[10px] font-black uppercase tracking-[0.16em]" style={{ color: theme.secondaryText || theme.text }}>
                Type DELETE to confirm
              </p>
              <input
                type="text"
                value={deleteInput}
                onChange={(event) => onDeleteInputChange(event.target.value)}
                className="lumirae-ds-input mt-3 w-full p-4 text-center font-black uppercase tracking-widest text-red-500"
                autoComplete="off"
              />
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <button type="button" onClick={onCancel} className="lumirae-ds-button lumirae-ds-button-secondary px-5 py-4">
                Cancel
              </button>
              <button
                type="button"
                onClick={onConfirm}
                disabled={!canDelete}
                className="lumirae-ds-button lumirae-ds-button-danger px-5 py-4 disabled:opacity-40"
              >
                <FaTrash className="mr-2 inline" /> Delete
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DeleteGiftModal;
